window.initFaqAccordions = function () {
  const faqAccordions = document.querySelectorAll(".pr-faq-item");
  const openFaqAccordion = (accordion) => {
    const content = accordion.querySelector(".pr-faq-content");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeFaqAccordion = (accordion) => {
    const content = accordion.querySelector(".pr-faq-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  if (faqAccordions.length > 0) {
    // openFaqAccordion(faqAccordions[0]);

    faqAccordions.forEach((accordion) => {
      const header = accordion.querySelector(".pr-faq-header");
      const content = accordion.querySelector(".pr-faq-content");

      accordion.onclick = () => {
        if (content.style.maxHeight) {
          closeFaqAccordion(accordion);
        } else {
          faqAccordions.forEach((accordion) => closeFaqAccordion(accordion));
          openFaqAccordion(accordion);
        }
      };
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  window.initFaqAccordions();
});



function initAddToCart() {
  document.querySelectorAll('.addon-button').forEach(button => {
    button.addEventListener('click', handleClick);
  });
}

function handleClick(e) {
  const form = e.target.closest('.addon-product-form');
  if (!form) return;

  e.preventDefault();
  handleAddToCart(form, e.target);
}

function handleAddToCart(form, button) {
  if (!form) return;

  const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  const productId = form.dataset.productId;
  const variantId = form.querySelector('.addon-variant-id').value;
  let sellingPlanId;
  const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
  if (sellingPlanInput) {
    sellingPlanId = sellingPlanInput.value;
  }

  const formData = new FormData(form);
  formData.append('id', variantId);
  if (sellingPlanId) {
    formData.append('selling_plan', sellingPlanId);
  }

  if (cartDrawer) {
    formData.append(
      'sections',
      getSectionsToRender(cartDrawer).map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
  }

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        throw new Error(response.message);
      }
      if (cartDrawer) {
        cartDrawer.renderContents(response);
        openCartDrawer();
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
}

function getSectionsToRender(cartDrawer) {
  return cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender() : [];
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.remove('is-empty');
    cartDrawer.open();
  }
}

initAddToCart();